import {checkiffilterispresentfabric} from "components/Content/HelperforOTB";
import React, {Component, useContext, useEffect, useState} from 'react';
import 'components/Content/ObjectToolbar.css'
import {CreationContext} from "../../containers/Content/CreationSuite";
import {fabric} from 'fabric'

export function DeleteSelectedObject () {

    const {value} = useContext(CreationContext);
    const [creationCanvas, setCreationCanvas]= value;

    const handleDeleteEvent = () => {
        creationCanvas.remove(creationCanvas.getActiveObject());
    }

    return (
        <div className="float-child-del">
            <button className="button delete"
                    title="Delete"
                    name="delete"
                    onClick={handleDeleteEvent}>
            </button>
        </div>
    )
}


export function FontOptions () {

    const {value} = useContext(CreationContext);
    const [creationCanvas, setCreationCanvas] = value;
    const [textVisible, setTextVisible] = useState('');

    const setBold = () => {
        if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null) {
            if (creationCanvas.getActiveObject().get("type") === "i-text") {
                creationCanvas.getActiveObject().set("fontStyle", "bold");
                creationCanvas.renderAll();
            }
        }
    }

    const setItalic = () => {
        if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null) {
            if (creationCanvas.getActiveObject().get("type") === "i-text") {
                creationCanvas.getActiveObject().set("fontStyle", "italic");
                creationCanvas.renderAll();
            }
        }
    }

    const handleFontColorChange = (e) => {
        if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null) {
            if (creationCanvas.getActiveObject().get("type") === "i-text") {
                creationCanvas.getActiveObject().set("fill", e.target.value.toString());
                creationCanvas.renderAll();
            }
        }
    }

    const handleFontSizeChange = (e) => {
        if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null) {
            if (creationCanvas.getActiveObject().get("type") === "i-text") {
                creationCanvas.getActiveObject().set("fontSize", e.target.value.toString());
                creationCanvas.renderAll();
            }
        }
    }

    const handleFontBackgroundChange = (e) => {
        if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null) {
            if (creationCanvas.getActiveObject().get("type") === "i-text") {
                creationCanvas.getActiveObject().set("backgroundColor", e.target.value.toString());
                creationCanvas.renderAll();
            }
        }
    }

    return (
        <div className="objectbar-text-options">

            <h1>
                Text Options
            </h1>

            <button className="button bold"
                    id = "bold-button"
                    title="Bold"
                    onClick={setBold}
                    name="bold">
            </button>

            <button className="button italic"
                    id = "italic button"
                    title="Italic"
                    onClick={setItalic}
                    name="italic">
            </button>

            <input className="button fill_text_c_button fill_text_c"
                   type="color"
                   title="Text Color"
                   onChange={handleFontColorChange}
                   name="color"
                   value=""
                   id="text-stroke-color"/>

            <input className="button fill_c_button fill_c"
                   type="color"
                   title="Background Color"
                   onChange={handleFontBackgroundChange}
                   name="bg-color"
                   value=""
                   id="text-stroke-color"/>

            <select style={{ background:' #e0e0e0' }}onChange={handleFontSizeChange}>

                <option value={100}>
                    100pt
                </option>

                <option value={90}>
                    90pt
                </option>

                <option value={75}>
                    75pt
                </option>

                <option value={50}>
                    50pt
                </option>

                <option value={35}>
                    35pt
                </option>

                <option value={20}>
                    20pt
                </option>

                <option value={15}>
                    15pt
                </option>

                <option value={10}>
                    10pt
                </option>

            </select>


        </div>
    )
}

export function ShapeOptions () {

    const {value} = useContext(CreationContext);
    const [creationCanvas, setCreationCanvas] = value;

    const setShapeFillColor = (e) => {
        if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null)
            if (creationCanvas.getActiveObject().get("type") === "circle"
                || creationCanvas.getActiveObject().get("type") === "rect"
                || creationCanvas.getActiveObject().get("type") === "polygon"
                || creationCanvas.getActiveObject().get("type") === "line" ) {

                creationCanvas.getActiveObject().set("fill", e.target.value.toString());
                creationCanvas.renderAll();

            }
        }

    const setShapeBorderColor = (e) => {
        if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null)

            if (creationCanvas.getActiveObject().get("type") === "circle"
                || creationCanvas.getActiveObject().get("type") === "rect"
                || creationCanvas.getActiveObject().get("type") === "polygon"
                || creationCanvas.getActiveObject().get("type") === "line" ) {

                creationCanvas.getActiveObject().set("stroke", e.target.value.toString());
                creationCanvas.renderAll();

            }
        }

        const setDashedStroke = (e) => {
        if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null)

            if (creationCanvas.getActiveObject().get("type") === "circle"
                || creationCanvas.getActiveObject().get("type") === "rect"
                || creationCanvas.getActiveObject().get("type") === "polygon"
                || creationCanvas.getActiveObject().get("type") === "line" ) {

                creationCanvas.getActiveObject().set("strokeDashArray", [e.target.value.toString()]);
                creationCanvas.renderAll();

            }
        }

        const setStrokeWidth = (e) => {
        if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null)

            if (creationCanvas.getActiveObject().get("type") === "circle"
                || creationCanvas.getActiveObject().get("type") === "rect"
                || creationCanvas.getActiveObject().get("type") === "polygon"
                || creationCanvas.getActiveObject().get("type") === "line" ) {

                let newStrokeWeight = e.target.value / creationCanvas.getActiveObject().scaleX;

                creationCanvas.getActiveObject().set('strokeWidth',newStrokeWeight);
                creationCanvas.renderAll();

            }
        }

    return (
        <div class="objectbar-shape-options">

            <h1>
                Shape Options
            </h1>

            <input type="color"
                   title="Fill Color"
                   class ="button fill_c_button fill_c"
                   name="fill"
                   value=""
                   id="shape-stroke-color"
                   onChange={setShapeFillColor}/>

            <input type="color"
                   title="Border Color"
                   class="button fill_border_button fill_border"
                   name="stroke"
                   value=""
                   id="shape-stroke-color"
                   onChange={setShapeBorderColor}/>

            <div class="dropdown"
                 title="Dotted Lines">

                <button class="button dropbtn_dash"/>

                <div class="dropdown-content">
                    <input type="range"
                           min="0"
                           name="dash"
                           max="10"
                    onChange={setDashedStroke}/>
                </div>

            </div>

            <input type="range"
                   min="0"
                   name="dash"
                   max="10"
            onChange={setStrokeWidth}/>

        </div>
    )
}

export function ImageOptions () {

    const {value} = useContext(CreationContext);
    const [creationCanvas, setCreationCanvas] = value;
    const [disabled, setDisabled] = useState(false);


    const applyGrayscaleFilter = () => {
         if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null)
            if (creationCanvas.getActiveObject().get("type") === "image"){

                let exists = checkiffilterispresentfabric(creationCanvas.getActiveObject().filters, "Grayscale");

                if (exists === -1) {
                    creationCanvas.getActiveObject().filters.push(new fabric.Image.filters.Grayscale());
                } else {
                    creationCanvas.getActiveObject().filters.splice(exists, 1);
                }
                creationCanvas.getActiveObject().applyFilters();
                creationCanvas.renderAll();
            }
    }

    const applyBlackAndWhiteFilter = () => {
         if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null)
            if (creationCanvas.getActiveObject().get("type") === "image"){

                let exists = checkiffilterispresentfabric(creationCanvas.getActiveObject().filters, "BlackWhite");

                if (exists === -1) {
                    creationCanvas.getActiveObject().filters.push(new fabric.Image.filters.BlackWhite());
                } else {
                    creationCanvas.getActiveObject().filters.splice(exists, 1);
                }
                creationCanvas.getActiveObject().applyFilters();
                creationCanvas.renderAll();
            }
    }


    const applyBrownieFilter = () => {
         if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null)
            if (creationCanvas.getActiveObject().get("type") === "image"){

                let exists = checkiffilterispresentfabric(creationCanvas.getActiveObject().filters, "Brownie");

                if (exists === -1) {
                    creationCanvas.getActiveObject().filters.push(new fabric.Image.filters.Brownie());
                } else {
                    creationCanvas.getActiveObject().filters.splice(exists, 1);
                }
                creationCanvas.getActiveObject().applyFilters();
                creationCanvas.renderAll();
            }
    }

    const applyEmbossFilter = () => {
         if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null)
            if (creationCanvas.getActiveObject().get("type") === "image"){

                let exists = checkiffilterispresentfabric(creationCanvas.getActiveObject().filters, "Convolute", 2);

                if (exists === -1) {
                    creationCanvas.getActiveObject().filters.push(new fabric.Image.filters.Convolute({
                        matrix: [ 1,   1,  1,
                                  1, 0.7, -1,
                                  -1,  -1, -1 ]}));
                } else {
                    creationCanvas.getActiveObject().filters.splice(exists, 1);
                }
                creationCanvas.getActiveObject().applyFilters();
                creationCanvas.renderAll();
            }
    }


    const applyInvertFilter = () => {
         if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null)
            if (creationCanvas.getActiveObject().get("type") === "image"){

                let exists = checkiffilterispresentfabric(creationCanvas.getActiveObject().filters, "Invert");

                if (exists === -1) {
                    creationCanvas.getActiveObject().filters.push(new fabric.Image.filters.Invert());
                } else {
                    creationCanvas.getActiveObject().filters.splice(exists, 1);
                }
                creationCanvas.getActiveObject().applyFilters();
                creationCanvas.renderAll();
            }
    }

    const applyKodachromeFilter = () => {
         if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null)
            if (creationCanvas.getActiveObject().get("type") === "image"){

                let exists = checkiffilterispresentfabric(creationCanvas.getActiveObject().filters, "Kodachrome");

                if (exists === -1) {
                    creationCanvas.getActiveObject().filters.push(new fabric.Image.filters.Kodachrome());
                } else {
                    creationCanvas.getActiveObject().filters.splice(exists, 1);
                }
                creationCanvas.getActiveObject().applyFilters();
                creationCanvas.renderAll();
            }
    }

    const applyPolaroidFilter = () => {
         if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null)
            if (creationCanvas.getActiveObject().get("type") === "image"){
                let exists = checkiffilterispresentfabric(creationCanvas.getActiveObject().filters, "Polaroid");

                if (exists === -1) {
                    creationCanvas.getActiveObject().filters.push(new fabric.Image.filters.Polaroid());
                } else {
                    creationCanvas.getActiveObject().filters.splice(exists, 1);
                }
                creationCanvas.getActiveObject().applyFilters();
                creationCanvas.renderAll();
            }
    }

    const applySepiaFilter = () => {
         if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null)
            if (creationCanvas.getActiveObject().get("type") === "image"){
                let exists = checkiffilterispresentfabric(creationCanvas.getActiveObject().filters, "Sepia");

                if (exists === -1) {
                    creationCanvas.getActiveObject().filters.push(new fabric.Image.filters.Sepia());
                } else {
                    creationCanvas.getActiveObject().filters.splice(exists, 1);
                }
                creationCanvas.getActiveObject().applyFilters();
                creationCanvas.renderAll();
            }
    }

    const applySharpenFilter = () => {
         if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null) {
            if (creationCanvas.getActiveObject().get("type") === "image"){
                let exists = checkiffilterispresentfabric(creationCanvas.getActiveObject().filters, "Convolute", 1);
                if (exists === -1) {
                    creationCanvas.getActiveObject().filters.push(new fabric.Image.filters.Convolute({
                        matrix: [0, -1, 0,
                            -1, 5, -1,
                            0, -1, 0]
                    }));
                } else {
                    creationCanvas.getActiveObject().filters.splice(exists, 1);
                }
                creationCanvas.getActiveObject().applyFilters();
                creationCanvas.renderAll();
            }
         }
    }

    const applyTechnicolorFilter = () => {
        if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null) {
            if (creationCanvas.getActiveObject().get("type") === "image") {
                let exists = checkiffilterispresentfabric(creationCanvas.getActiveObject().filters, "Technicolor");

                if (exists === -1) {
                    creationCanvas.getActiveObject().filters.push(new fabric.Image.filters.Technicolor());
                } else {
                    creationCanvas.getActiveObject().filters.splice(exists, 1);
                }
                creationCanvas.getActiveObject().applyFilters();
                creationCanvas.renderAll();
            }
        }
    }

    const applyVintageFilter = () => {
         if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null) {
             if (creationCanvas.getActiveObject().get("type") === "image") {
                let exists = checkiffilterispresentfabric(creationCanvas.getActiveObject().filters, "Vintage");

                if (exists === -1) {
                    creationCanvas.getActiveObject().filters.push(new fabric.Image.filters.Vintage());
                } else {
                    creationCanvas.getActiveObject().filters.splice(exists, 1);
                }
                creationCanvas.getActiveObject().applyFilters();
                creationCanvas.renderAll();
             }
         }
    }

    const flipFunctionX = () => {
         if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null)
            if (creationCanvas.getActiveObject().get("type") === "image"){
                creationCanvas.getActiveObject().toggle('flipX');
                creationCanvas.renderAll();
            }
    }

    const flipFunctionY = () => {
         if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null)
            if (creationCanvas.getActiveObject().get("type") === "image"){
                creationCanvas.getActiveObject().toggle('flipY');
                creationCanvas.renderAll();
            }
    }

    const cropImage = () => {
        if (creationCanvas.getActiveObject() !== undefined && creationCanvas.getActiveObject() !== null)
            if (creationCanvas.getActiveObject().get("type") === "image") {
                let counter = 0;
                let mouseDown = false;
                let mouseDownLocation;
                let cropRectangle = new fabric.Rect({
                    fill: 'transparent',
                    stroke: '#FF0000',
                    strokeDashArray: [2, 2],
                    visible: true
                });

                let container = document.getElementById('CreationCanvas').getBoundingClientRect();
                console.log(container)

                creationCanvas.add(cropRectangle);
                creationCanvas.getActiveObject().selectable = false;
                console.log(creationCanvas.getActiveObject())

                creationCanvas.renderAll();


                creationCanvas.on("mouse:down", function (event) {
                    if (counter === 0) {
                        let downClick = creationCanvas.getPointer(event.e);
                        console.log(event)
                        console.log("inside mousedown")
                        mouseDownLocation = event.e;
                        cropRectangle.width = 2;
                        cropRectangle.height = 2;
                        cropRectangle.left = downClick.x;
                        cropRectangle.top = downClick.y;
                        cropRectangle.visible = true;
                        mouseDown = true;
                        creationCanvas.bringToFront(cropRectangle);
                    }
                });


                creationCanvas.on("mouse:move", function (event) {
                    if (mouseDown && counter === 0) {
                        console.log("inside mousemove")
                        cropRectangle.width = event.e.pageX - mouseDownLocation.pageX;
                        cropRectangle.height = event.e.pageY - mouseDownLocation.pageY;
                        console.log(cropRectangle.width)
                        console.log(cropRectangle.height)
                        creationCanvas.renderAll();
                    }
                });


                creationCanvas.on("mouse:up", function (event) {
                    if (counter === 0) {
                        console.log("inside mouseup")
                        console.log(event)
                        mouseDown = null;
                        creationCanvas.getActiveObject().selectable = true;
                        cropRectangle.visible = true;
                        creationCanvas.renderAll();
                        let cropped = new Image();
                        console.log(cropRectangle.aCoords)
                        console.log(cropRectangle.left)
                        console.log(cropRectangle.top)
                        cropped.src = creationCanvas.toDataURL({
                            left: cropRectangle.left,
                            top: cropRectangle.top,
                            width: cropRectangle.width,
                            height: cropRectangle.height
                        });

                        cropped.onload = () => {
                            creationCanvas.remove(creationCanvas.getActiveObject());
                            let img;
                            img = new fabric.Image(cropped);
                            console.log(img)
                            img.left = cropRectangle.left;
                            img.top = cropRectangle.top;
                            img.width = cropRectangle.width;
                            img.height = cropRectangle.height;
                            console.log(img.top)
                            img.setCoords();
                            creationCanvas.add(img);
                            creationCanvas.renderAll();
                            setDisabled(true);
                            //canvas.getActiveObject().selectable = true;
                            //this.setState({disabled : true})
                            console.log(cropRectangle.aCoords)
                            creationCanvas.remove(cropRectangle);
                            counter = 1;
                        }
                    }
                    ;
                });

                console.log(disabled)
                creationCanvas.getActiveObject().selectable = true;
                creationCanvas.renderAll();

            }
    }



    return (
        <div class="objectbar-image-options">

            <h1>
                Image Options
            </h1>

            <button className="button flipx"
                    title="Flip over X"
                    name="flipx"
                    onClick={flipFunctionX}>
            </button>

            <button className="button flipy"
                    title="Flip over Y"
                    name="flipy"
                    onClick={flipFunctionY}>
            </button>

            <div class="dropdown"
                 title="Filters">

                <button className="buttontextdd">
                    Filters
                </button>

                <div class="dropdown-content-filters">
                    <button className="buttontext"
                            title="Grayscale"
                            name="Apply Grayscale Filter"
                            onClick={applyGrayscaleFilter}>
                        Grayscale
                    </button>

                    <button className="buttontext"
                            title="Sepia"
                            name="Apply Sepia Filter"
                            onClick={applySepiaFilter}>
                        Sepia
                    </button>

                    <button className="buttontext"
                            title="Black White"
                            name="Apply Black White Filter"
                            onClick={applyBlackAndWhiteFilter}>
                        Black/White
                    </button>

                    <button className="buttontext"
                            title="Brownie"
                            name="Apply Brownie Filter"
                            onClick={applyBrownieFilter}>
                        Brownie
                    </button>

                    <button className="buttontext"
                            title="Vintage"
                            name="Apply Vintage Filter"
                            onClick={applyVintageFilter}>
                        Vintage
                    </button>

                    <button className="buttontext"
                            title="Kodachrome"
                            name="Apply Kodachrome Filter"
                            onClick={applyKodachromeFilter}>
                        Kodachrome
                    </button>

                    <button className="buttontext"
                            title="Technicolor"
                            name="Apply Technicolor Filter"
                            onClick={applyTechnicolorFilter}>
                        Technicolor
                    </button>

                    <button className="buttontext"
                            title="Polaroid"
                            name="Apply Polaroid Filter"
                            onClick={applyPolaroidFilter}>
                        Polaroid
                    </button>

                    <button className="buttontext"
                            title="Sharpen"
                            name="Apply Sharpen Filter"
                            onClick={applySharpenFilter}>
                        Sharpen
                    </button>

                    <button className="buttontext"
                            title="Emboss"
                            name="Apply Emboss Filter"
                            onClick={applyEmbossFilter}>
                        Emboss
                    </button>

                    <button className="buttontext"
                            title="Invert"
                            name="Invert Colors on Photo"
                            onClick={applyInvertFilter}>
                        Invert
                    </button>

                </div>
            </div>

            <button className="button crop"
                    title="Crop"
                    name="Crop Image"
                    onClick={cropImage}>
            </button>

        </div>

    )
}
export function ObjectOptions () {

    const {value} = useContext(CreationContext);
    const [creationCanvas, setCreationCanvas] = value;

    const moveObject=(e)=>{
             if(e.target.name==="moveToFront"){
                 creationCanvas.bringToFront(creationCanvas.getActiveObject());
                 console.log("moveToFront");
             }
             else if (e.target.name==="moveToBack") {
                 creationCanvas.sendToBack(creationCanvas.getActiveObject());
             }
             else if (e.target.name==="moveBackward") {
                 creationCanvas.sendBackwards(creationCanvas.getActiveObject());
             }
             else if (e.target.name==="moveForward") {
                 creationCanvas.bringForward(creationCanvas.getActiveObject());
             }
             creationCanvas.renderAll();
             //this.props.fireEvent();
         }
    const undo=()=>{
        creationCanvas.undo();
    }
    const redo=()=>{
        creationCanvas.redo();
    }

    return (
        <div class="objectbar-object-options">

            <h1>
                Object Options
            </h1>

            <button className="button compforward" title="MoveForward" name="moveForward" onClick={moveObject}></button>
            <button className="button forward" title="Move to front" name="moveToFront"onClick={moveObject}></button>
            <button className="button compbackward" title="MoveBackward" name="moveBackward" onClick={moveObject}></button>
            <button className="button backward" title="Move to back" name="moveToBack" onClick={moveObject}></button>
            <button className="button undo" title="Undo" onClick={undo}></button>
            <button className="button redo" title="Redo" onClick={redo}></button>
        </div>
    )
    }
class ObjectToolBar extends Component {
    //
    // constructor(props) {
    //     super(props);
    //     this.state = {
    //         boldStyle: {},
    //         italicStyle: {},
    //         mouseDown: true,
    //         disabled: false,
    //     };
    // }
    //
    // setStyle=(object, styleName, value)=> {
    //   if (object.setSelectionStyles && object.isEditing) {
    //     var style = { };
    //     style[styleName] = value;
    //     object.setSelectionStyles(style);
    //     console.log(object.getSelectionStyles())
    //   }
    //   else {
    //     object[styleName] = value;
    //   }
    // }
    //
    // getStyle=(object, styleName, value)=> {
    //     if (object.getSelectionStyles && object.isEditing){
    //         let styles = object.getSelectionStyles()
    //         console.log(styles);
    //         for (let style of styles){
    //             if (!style[styleName] || style[styleName] !== value){
    //                 return false
    //             }
    //         }
    //         return true
    //     }
    //     else{return(object[styleName]===value?true : false);}
    //
    // }
    //
    // addHandler=(fn)=>{
    //     let canvas = this.props.canvas;
    //     if (canvas.getActiveObject()) {
    //       fn(canvas.getActiveObject());
    //       canvas.renderAll();
    //     };
    // }
    //
    //
    //
    // setOpacity=(e)=>{
    //     let canvas = this.props.canvas
    //     if(canvas.getActiveObject()){
    //         console.log(parseInt(e.target.value)/100);
    //         var obj = canvas.getActiveObject();
    //         obj.set({
    //             opacity: parseInt(e.target.value)/100
    //         });
    //         // canvas.getActiveObject()[opacity] =
    //         canvas.renderAll();
    //         this.props.fireEvent();
    //     }
    // }
    //
    //
    // crop=()=>{
    //     let counter = 0;
    //     let disabled= this.state.disabled;
    //     console.log(this.state.disabled)
    //     let mouseDown = false;
    //     let mouseDownLocation;
    //     let rectangle = new fabric.Rect({
    //         fill: 'transparent',
    //         stroke: '#FF0000',
    //         strokeDashArray: [2, 2],
    //         visible: true
    //     });
    //
    //     let container = document.getElementById('canvas').getBoundingClientRect();
    //     let canvas = this.props.canvas;
    //
    //     canvas.add(rectangle);
    //     canvas.getActiveObject().selectable = false;
    //     console.log(canvas.getActiveObject())
    //     canvas.renderAll();
    //
    //
    //         canvas.on("mouse:down", function (event) {
    //             if(counter === 0) {
    //                 console.log("inside mousedown")
    //                 console.log(mouseDown);
    //                 rectangle.width = 2;
    //                 rectangle.height = 2;
    //                 rectangle.left = event.e.pageX - container.left;
    //                 console.log(rectangle.left)
    //                 rectangle.top = event.e.pageY - container.top;
    //                 console.log(rectangle.left)
    //                 rectangle.visible = true;
    //                 mouseDown = true;
    //                 mouseDownLocation = event.e;
    //                 canvas.bringToFront(rectangle);
    //             }
    //         });
    //
    //
    //     canvas.on("mouse:move", function (event) {
    //         if (mouseDown && counter === 0) {
    //             console.log("inside mousemove")
    //             rectangle.width = event.e.pageX - mouseDownLocation.pageX;
    //             rectangle.height = event.e.pageY - mouseDownLocation.pageY;
    //             console.log(rectangle);
    //             canvas.renderAll();
    //         }
    //     });
    //
    //
    //     canvas.on("mouse:up", function (event) {
    //         if(counter === 0){
    //         console.log("inside mouseup")
    //         console.log(event)
    //         mouseDown = null;
    //         canvas.getActiveObject().selectable = true;
    //         rectangle.visible = true;
    //         canvas.renderAll();
    //         let cropped = new Image();
    //         cropped.src = canvas.toDataURL({
    //             left: rectangle.left,
    //             top: rectangle.top,
    //             width: rectangle.width,
    //             height: rectangle.height
    //         });
    //
    //         cropped.onload =()=> {
    //             canvas.remove(canvas.getActiveObject());
    //             let img;
    //             img = new fabric.Image(cropped);
    //             console.log(img)
    //             img.left = rectangle.left;
    //             console.log(img.left)
    //             img.top = rectangle.top;
    //             img.width = rectangle.width;
    //             img.height = rectangle.height;
    //             console.log(img.top)
    //             img.setCoords();
    //             canvas.add(img);
    //             canvas.renderAll();
    //             disabled = true;
    //             console.log(disabled)
    //             //canvas.getActiveObject().selectable = true;
    //             //this.setState({disabled : true})
    //             canvas.remove(rectangle);
    //             counter = 1;
    //         }
    //         };
    //     });
    //
    //     console.log(disabled)
    //     canvas.getActiveObject().selectable = true;
    //     //this.setState({disabled : true})
    //     //canvas.remove(rectangle);
    //     canvas.renderAll();
    //
    // }
    //
    // moveObject=(e)=>{
    //     let canvas = this.props.canvas
    //     if(e.target.name==="moveToFront"){
    //         canvas.bringToFront(canvas.getActiveObject());
    //     }
    //     else if (e.target.name==="moveToBack") {
    //         canvas.sendToBack(canvas.getActiveObject());
    //     }
    //     else if (e.target.name==="moveBackward") {
    //         canvas.sendBackwards(canvas.getActiveObject());
    //     }
    //     else if (e.target.name==="moveForward") {
    //         canvas.bringForward(canvas.getActiveObject());
    //     }
    //     this.props.fireEvent();
    // }
    // flipx=(e)=>{
    //
    //     //console.log(this.props.selectedObjectType);
    //     //console.log(canvas.getActiveObject());
    //     //console.log(canvas.getActiveObject().width);
    //     //console.log(canvas.getActiveObject()._element);
    //
    //
    //     //Code adapted from here: https://stackoverflow.com/questions/43699136/fabricjs-flipx-object
    //     let canvas = this.props.canvas;
    //
    //     canvas.getActiveObject().toggle('flipY');
    //     canvas.renderAll();
    //
    //     //Below are some ways that work if using canvas and not fabric.js
    //     //Most code taken from: https://stackoverflow.com/questions/35973441/how-to-horizontally-flip-an-image
    //     //let ctx = canvas.getContext('2d');
    //     //var horizontal = true;
    //     //var vertical = true;
    //     //var x = 0, y = 0;
    //     //ctx.save();
    //     //var img = canvas.getActiveObject()._element;
    //     //ctx.translate(canvas.getActiveObject().left + canvas.getActiveObject().width, canvas.getActiveObject().top);
    //     //ctx.scale(-1, 1);
    //     //ctx.drawImage(canvas.getActiveObject()._element, canvas.width - 1, 0, canvas.getActiveObject().width, canvas.getActiveObject().height);
    //     //ctx.setTransform(
    //     //    horizontal ? -1 : 1, 0, // set the direction of x axis
    //     //    0, vertical ? -1 : 1,   // set the direction of y axis
    //     //    x + horizontal ? canvas.getActiveObject().width : 0, // set the x origin
    //     //    y + vertical ? canvas.getActiveObject().height : 0   // set the y origin
    //     //);
    //     //ctx.drawImage(canvas.getActiveObject()._originalElement, 0, 0);
    //     //ctx.setTransform(-1,0,0,1,canvas.width, 0);
    //     //ctx.drawImage(img, 0, 0, canvas.getActiveObject().width, canvas.getActiveObject().height);
    //     //ctx.setTransform(1,0,0,1,0,0);
    //     //ctx.restore();
    //     //ctx.setTransform(1,0,0,1,0,0);
    //     //canvas.remove(canvas.getActiveObject());
    //
    //     this.props.fireEvent();
    // }
    // flipy=(e)=>{
    //     let canvas = this.props.canvas;
    //
    //     canvas.getActiveObject().toggle('flipX');
    //     canvas.renderAll();
    //
    //     this.props.fireEvent();
    // }
    // afgrayscale=(e)=>{
    //     let canvas = this.props.canvas;
    //
    //     let exists = checkiffilterispresentfabric(canvas.getActiveObject().filters, "Grayscale");
    //     //console.log(canvas.getActiveObject().filters[0]);
    //     if (exists === -1) {
    //         canvas.getActiveObject().filters.push(new fabric.Image.filters.Grayscale());
    //     } else {
    //         canvas.getActiveObject().filters.splice(exists, 1);
    //     }
    //     canvas.getActiveObject().applyFilters();
    //     canvas.renderAll();
    //
    //     //console.log(canvas.getActiveObject().filters[0].type);
    //     //console.log(canvas.getActiveObject());
    // }
    // afsepia=(e)=>{
    //     let canvas = this.props.canvas;
    //
    //     let exists = checkiffilterispresentfabric(canvas.getActiveObject().filters, "Sepia");
    //     if (exists === -1) {
    //         canvas.getActiveObject().filters.push(new fabric.Image.filters.Sepia());
    //     } else {
    //         canvas.getActiveObject().filters.splice(exists, 1);
    //     }
    //     canvas.getActiveObject().applyFilters();
    //     canvas.renderAll();
    // }
    // afwf=(e)=>{
    //     let canvas = this.props.canvas;
    //
    //     let exists = checkiffilterispresentfabric(canvas.getActiveObject().filters, "BlackWhite");
    //     if (exists === -1) {
    //         canvas.getActiveObject().filters.push(new fabric.Image.filters.BlackWhite());
    //     } else {
    //         canvas.getActiveObject().filters.splice(exists, 1);
    //     }
    //     canvas.getActiveObject().applyFilters();
    //     canvas.renderAll();
    // }
    // afbrownie=(e)=>{
    //     let canvas = this.props.canvas;
    //
    //     let exists = checkiffilterispresentfabric(canvas.getActiveObject().filters, "Brownie");
    //     if (exists === -1) {
    //         canvas.getActiveObject().filters.push(new fabric.Image.filters.Brownie());
    //     } else {
    //         canvas.getActiveObject().filters.splice(exists, 1);
    //     }
    //     canvas.getActiveObject().applyFilters();
    //     canvas.renderAll();
    // }
    // afvintage=(e)=>{
    //     let canvas = this.props.canvas;
    //
    //     let exists = checkiffilterispresentfabric(canvas.getActiveObject().filters, "Vintage");
    //     if (exists === -1) {
    //         canvas.getActiveObject().filters.push(new fabric.Image.filters.Vintage());
    //     } else {
    //         canvas.getActiveObject().filters.splice(exists, 1);
    //     }
    //     canvas.getActiveObject().applyFilters();
    //     canvas.renderAll();
    // }
    // afkoda=(e)=>{
    //     let canvas = this.props.canvas;
    //
    //     let exists = checkiffilterispresentfabric(canvas.getActiveObject().filters, "Kodachrome");
    //     if (exists === -1) {
    //         canvas.getActiveObject().filters.push(new fabric.Image.filters.Kodachrome());
    //     } else {
    //         canvas.getActiveObject().filters.splice(exists, 1);
    //     }
    //     canvas.getActiveObject().applyFilters();
    //     canvas.renderAll();
    // }
    // aftechni=(e)=>{
    //     let canvas = this.props.canvas;
    //
    //     let exists = checkiffilterispresentfabric(canvas.getActiveObject().filters, "Technicolor");
    //     if (exists === -1) {
    //         canvas.getActiveObject().filters.push(new fabric.Image.filters.Technicolor());
    //     } else {
    //         canvas.getActiveObject().filters.splice(exists, 1);
    //     }
    //     canvas.getActiveObject().applyFilters();
    //     canvas.renderAll();
    // }
    // afpolaroid=(e)=>{
    //     let canvas = this.props.canvas;
    //
    //     let exists = checkiffilterispresentfabric(canvas.getActiveObject().filters, "Polaroid");
    //     if (exists === -1) {
    //         canvas.getActiveObject().filters.push(new fabric.Image.filters.Polaroid());
    //     } else {
    //         canvas.getActiveObject().filters.splice(exists, 1);
    //     }
    //     canvas.getActiveObject().applyFilters();
    //     canvas.renderAll();
    // }
    // //Can only apply Sharpen or emboss filter right now as they both use the same filter so have to check values so using another
    // //method or change the image has an array of filters with each one having a specific index or just have one of them.
    // //Clicking on one right now while the other is present will get rid of the other filter.
    // afsharpen=(e)=>{
    //     let canvas = this.props.canvas;
    //
    //     let exists = checkiffilterispresentfabric(canvas.getActiveObject().filters, "Convolute", 1);
    //     if (exists === -1) {
    //         canvas.getActiveObject().filters.push(new fabric.Image.filters.Convolute({
    //             matrix: [  0, -1,  0,
    //             -1,  5, -1,
    //              0, -1,  0 ]}));
    //     } else {
    //         canvas.getActiveObject().filters.splice(exists, 1);
    //     }
    //     canvas.getActiveObject().applyFilters();
    //     canvas.renderAll();
    // }
    // afemboss=(e)=>{
    //     let canvas = this.props.canvas;
    //
    //     let exists = checkiffilterispresentfabric(canvas.getActiveObject().filters, "Convolute", 2);
    //     if (exists === -1) {
    //         canvas.getActiveObject().filters.push(new fabric.Image.filters.Convolute({
    //             matrix: [ 1,   1,  1,
    //             1, 0.7, -1,
    //            -1,  -1, -1 ]}));
    //     } else {
    //         canvas.getActiveObject().filters.splice(exists, 1);
    //     }
    //     //console.log(canvas.getActiveObject().filters);
    //     canvas.getActiveObject().applyFilters();
    //     canvas.renderAll();
    // }
    // afinvert=(e)=>{
    //     let canvas = this.props.canvas;
    //
    //     let exists = checkiffilterispresentfabric(canvas.getActiveObject().filters, "Invert");
    //     if (exists === -1) {
    //         canvas.getActiveObject().filters.push(new fabric.Image.filters.Invert());
    //     } else {
    //         canvas.getActiveObject().filters.splice(exists, 1);
    //     }
    //     canvas.getActiveObject().applyFilters();
    //     canvas.renderAll();
    // }
    // delete=(e)=>{
    //     let canvas = this.props.canvas
    //
    //     canvas.remove(canvas.getActiveObject());
    //     this.props.fireEvent();
    // }
    render() {
//        let boldStyle = this.state.boldStyle;
//        let italicStyle = this.state.italicStyle;
//        let state=this.props.state
        return (
            <div class="object-toolbar">
                {/*<div class="float-child">*/}
                {/*    <button className="button undo" title="Undo" onClick={this.props.undo}></button>*/}
                {/*    <button className="button redo" title="Redo" onClick={this.props.redo}></button>*/}
                {/*    <div className="dropdown" title="Opacity">*/}
                {/*        <button className="button opacity"></button>*/}
                {/*        <div className="dropdown-content">*/}
                {/*            <input type="range" min="10" onChange={this.setOpacity} max="100"/>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*    <button className="button compforward" title="MoveForward" name="moveForward" onClick={this.moveObject}></button>*/}
                {/*    <button className="button forward" title="Move to front" name="moveToFront"onClick={this.moveObject}></button>*/}
                {/*    <button className="button compbackward" title="MoveBackward" name="moveBackward" onClick={this.moveObject}></button>*/}
                {/*    <button className="button backward" title="Move to back" name="moveToBack" onClick={this.moveObject}></button>*/}

                {/*</div>*/}

                {/*        <div class="float-child">*/}
                {/*            <button className="button crop" title="Crop" name="Crop Image" onClick={this.crop}></button>*/}
                {/*        </div>*/}

                {/*    (<div class = "float-child"></div>)*/}
                {/*}*/}

                <FontOptions/>
                <ShapeOptions/>
                <ImageOptions/>
                <ObjectOptions/>
                <DeleteSelectedObject/>
            </div>
        );
    }

}

export default ObjectToolBar;
